import useSWR from 'swr'
import { useAuth } from '../store/auth.store'
import { AreaService } from '../services/area.service'
import { ServicesService } from '../services/services.service'
import { useParams } from 'react-router-dom'
import { useArea } from '../store/area.store'
import { DocumentService } from '../services/document.service'

const fetchData = async (
  userExId: string,
  areaCode: string,
  isAvaliable: boolean = false
): Promise<IDocument[]> => {
  return await DocumentService.getLastOrders(userExId,areaCode,isAvaliable)
}

const useDataLastOrders = (isAvaliable: boolean = false) => {
  const { user } = useAuth();
  const isDisabled = user?.permission?.permissionDetaileds[0]?.isOrdersView;
  const { choosedArea } = useArea();

  const key = isDisabled
    ? `/client/lastOrders/${user?.isPayCustomer ? '200' : choosedArea?.code}/${user?.isPayCustomer ? choosedArea?.code : user?.extId}${isAvaliable ? '?type=avaliable' : ''}`
    : null;

  const { data, error, isLoading, mutate } = useSWR<IDocument[]>(
    key,
    () => fetchData(
      user?.isPayCustomer ? choosedArea?.code! : user?.extId!,
      user?.isPayCustomer ? '200' : choosedArea?.code!,
      isAvaliable
    )
  );

  return {
    data,
    isLoading,
    isError: error,
    mutate,
  };
};

export default useDataLastOrders;


